/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('dialog_printPDFCtrl', ['$scope', '$rootScope', '$http', 'NetworkService', 'MainService', function ($scope, $rootScope, $http, NetworkService, MainService) {
function downloadFile(fileName, urlData) {

    var aLink = document.createElement('a');
    aLink.download = fileName;
    aLink.href = urlData;

    var event = new MouseEvent('click');
    aLink.dispatchEvent(event);
}
        $scope.printExcelList = function()
        {
            var dialog = MainService.getDialogData('dialog_printPDFCtrl')
            var eventId = dialog.event_id
            NetworkService.generateEmailList(-1,eventId, function (data) {
                downloadFile('2.csv', 'data:text/csv;charset=UTF-8,' + '\uFEFF' + encodeURIComponent(data));
            })
        }
        $scope.printParticipantList = function ()
        {
            var dialog = MainService.getDialogData('dialog_printPDFCtrl')
            eventId = dialog.event_id
            window.getPDFList(eventId)
        }
        
        $scope.printTshirtList = function ()
        {
            var dialog = MainService.getDialogData('dialog_printPDFCtrl')
            eventId = dialog.event_id
            window.getPDFTshirtList(eventId, 121)
        }
        
        $scope.getShiftList = function ()
        {
            
            var dialog = MainService.getDialogData('dialog_printPDFCtrl')
            eventId = dialog.event_id
            window.getShiftList(eventId, 121)
        }
    }])